import { ApplicationInsights } from '@microsoft/1ds-analytics-web-js';
import { ClientLoggerTelemetry, clientLoggerConfig, SystemLoggerTelemetry } from '@shared/logger';
import { ServerLogger, winstonLogger } from '@server/serverLogger';
import { Logger } from './logger';
import { scrubField } from '@shared/utils/scrubbingUtils';
const clientLogger = new ClientLoggerTelemetry();
const serverLogger = new ServerLogger();
export const logger = new Logger(clientLogger, serverLogger);
export const systemLogger = new SystemLoggerTelemetry();
export const ensureClientLoggerInitialization = (store)=>{
    if (!logger.clientLogger.logger) {
        const _1dsLogger = new ApplicationInsights();
        _1dsLogger.initialize(clientLoggerConfig(), []);
        _1dsLogger.addTelemetryInitializer((envelope)=>{
            var _envelope_baseData, _envelope_data, _envelope_baseData1, _envelope_data_baseData, _envelope_data1;
            if (envelope === null || envelope === void 0 ? void 0 : (_envelope_baseData = envelope.baseData) === null || _envelope_baseData === void 0 ? void 0 : _envelope_baseData.target) {
                envelope.baseData.target = scrubField(envelope.baseData.target);
            }
            if (envelope === null || envelope === void 0 ? void 0 : (_envelope_data = envelope.data) === null || _envelope_data === void 0 ? void 0 : _envelope_data.uri) {
                envelope.data.uri = scrubField(envelope.data.uri);
            }
            if (envelope === null || envelope === void 0 ? void 0 : (_envelope_baseData1 = envelope.baseData) === null || _envelope_baseData1 === void 0 ? void 0 : _envelope_baseData1.uri) {
                envelope.baseData.uri = scrubField(envelope.baseData.uri);
            }
            if (envelope === null || envelope === void 0 ? void 0 : (_envelope_data1 = envelope.data) === null || _envelope_data1 === void 0 ? void 0 : (_envelope_data_baseData = _envelope_data1.baseData) === null || _envelope_data_baseData === void 0 ? void 0 : _envelope_data_baseData.uri) {
                envelope.data.baseData.uri = scrubField(envelope.data.baseData.uri);
            }
        });
        logger.clientLogger.initialize(_1dsLogger, store);
        systemLogger.initialize(_1dsLogger, store);
    }
};
export const initServerLogger = ()=>{
    if (!logger.serverLogger.logger) {
        const _winstonLogger = winstonLogger();
        logger.serverLogger.init(_winstonLogger);
    }
};
